import { render } from "./ViewportCube.vue?vue&type=template&id=164d05ce"
import script from "./ViewportCube.vue?vue&type=script&lang=js"
export * from "./ViewportCube.vue?vue&type=script&lang=js"

import "./ViewportCube.vue?vue&type=style&index=0&id=164d05ce&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__